export const AdminRoute = {
  SIGN_IN: 'admin/sign-in',
  TEST_PAGE: 'test-page',
}